export default "__VITE_ASSET__985b65c3__"